import * as React from 'react';
import { Container, Item } from '../../../../../../components/Grid';
import HistoryRow from '../../../../../../components/HistoryRow';
import HistoryRowControls from '../../../../../../components/HistoryRowControls';
import HistoryRowListing from '../../../../../../components/HistoryRowListing';
import { IHistoryContext } from '../../../../../../containers/FormContextHandler';
import { formatPartialDate } from 'Utility/date';
import { fm } from 'Components/FormatMessage';
import { newButton } from '../../../../utils/functions';

const SleepApneaSeverityHistory = ({
  documents = [],
  startEdit,
}: IHistoryContext<ISleepApneaSeverity>): React.JSX.Element => {
  return (
    <HistoryRow
      headerText={fm('diagnosis.sleepApnea.sleepApneaSeverity.title')}
      rowButton={
        startEdit ? newButton('sleepApneaSeverity', startEdit({}, 'sleepApneaSeverity'), 'general.new', 15) : undefined
      }
    >
      <HistoryRowListing
        documents={documents}
        headers={
          <Item xs={12}>
            <Container>
              <Item xs={5}>{fm('general.date')}</Item>
              <Item xs={7}>{fm('diagnosis.sleepApnea.sleepApneaSeverity.severity')}</Item>
            </Container>
          </Item>
        }
        contentFormat={(d: ISleepApneaSeverity): React.JSX.Element => (
          <Item xs={12}>
            <Container>
              <Item xs={5}>{d?.date ? formatPartialDate(d?.date) : '-'}</Item>
              <Item xs={5}>
                {d?.severity ? fm(`diagnosis.sleepApnea.sleepApneaSeverity.opts.${d?.severity}`) : '-'}
              </Item>
              <Item xs={2}>{startEdit ? <HistoryRowControls document={d} startEdit={startEdit} /> : null}</Item>
            </Container>
          </Item>
        )}
        collapse={false}
      />
    </HistoryRow>
  );
};

export default SleepApneaSeverityHistory;
